'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getApiStubData;

var _cookie = require('../../utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _flatPath = require('./flatPath');

var _flatPath2 = _interopRequireDefault(_flatPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function getApiStubData(_ref) {
    var apiStubUrl = _ref.url;

    var stubDataUrl = (0, _cookie2.default)('apiStubs');
    if (!stubDataUrl || !apiStubUrl) {
        return Promise.resolve(null);
    }
    return Promise.resolve(stubDataUrl).then(function (group) {
        return JSON.parse(group);
    }).then(function (stubInfo) {
        return fetch(apiStubUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            },
            body: 'type=diffusion&group=' + encodeURIComponent(stubInfo.case)
        });
    }).then(function (response) {
        return response.json();
    }).then(function (diffusionData) {
        var steps = [];
        if (diffusionData.initial) {
            steps.push(diffusionData.initial);
        }
        if (diffusionData.steps) {
            steps.push.apply(steps, _toConsumableArray(diffusionData.steps));
        }
        return steps.map(_flatPath2.default).reduce(function (acc, item, index) {
            var actions = Object.keys(item).map(function (topic) {
                return {
                    topic: topic,
                    value: item[topic],
                    step: index
                };
            });
            return [].concat(_toConsumableArray(acc), _toConsumableArray(actions));
        }, []);
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/providers/stub/apiStubLoader.js
// module id = 1497
// module chunks = 1